export default __webpack_public_path__ + "static/media/image3.bd53381f.jpg";